import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import ReactTable from 'react-table';
import Button from 'react-bootstrap/lib/Button';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import getSortHeaderProps from '../../utils/get-sorted-headers';
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  InputGroup,
  Row,
} from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class JogTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: [],
    };
  }

  componentDidMount () {
    const { device, jogStore } = this.props;
    jogStore.loadJog(device);
  }

  renderEditable = (cellInfo, step = 1.00, unit) => {
    const { jogStore, device } = this.props;

    if (device.autoTuning) {
      return (
        <div>{cellInfo.row[cellInfo.column.id]}</div>
      );
    }

    return (
      <InputGroup>
        <FormControl
          name={cellInfo.row[cellInfo.column.id]}
          type="number"
          min={0}
          step={step}
          value={cellInfo.row[cellInfo.column.id] || 0}
          onChange={e => {
            jogStore.changeJog(
              cellInfo.row.id,
              cellInfo.column.id,
              e.target.value
            );
          }}
          bsSize="sm"
        />
        <InputGroup.Addon>
          {unit}
        </InputGroup.Addon>
      </InputGroup>
    );
  };

  renderTest = cellInfo => {
    const { jogStore, batchStore, device } = this.props;
    const { material, jogArray } = jogStore;

    if (device.autoTuning) {
      return '';
    }

    return (
      <div className="text-right">
        <button className="btn btn-sm btn-default btn-action"
          disabled={batchStore.jogTestRunning}
          title="Test"
          onClick={(e) => {
            e.preventDefault();
            batchStore.runJogTest(material, jogArray, device, cellInfo.row.id);
          }}
        >
          <i className="fa fa-play"/>
        </button>
      </div>
    );
  };

  getColumns = (material = {}, t) => {
    const { itemBatchUnitSymbol } = material;
    const { sorted } = this.state;

    return [
      {
        headerText: t('ID'),
        accessor: 'id',
        id: 'id',
        width: 70,
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Jog Open'),
        accessor: 'open',
        id: 'open',
        ...getSortHeaderProps(sorted),
        Cell: cellInfo => this.renderEditable(cellInfo, 0.05, 'sec'),
      },
      {
        headerText: t('Jog Weight'),
        accessor: 'weight',
        id: 'weight',
        ...getSortHeaderProps(sorted),
        Cell: cellInfo => this.renderEditable(cellInfo, 0.01, itemBatchUnitSymbol),
      },
      {
        headerText: '',
        accessor: 'action',
        id: 'action',
        width: 70,
        ...getSortHeaderProps(sorted),
        Cell: this.renderTest,
      },
    ];
  };

  render() {
    const { jogStore, batchStore, onClose, device, t } = this.props;
    const {
      material,
      materialId,
      saveJog,
      jogTable,
      jogInterval,
      setJogInterval,
      loading,
      jogArray,
      saving,
      clear,
      interpolate,
    } = jogStore;

    const handleJogIntervalChange = e => {
      setJogInterval(Number(e.target.value));
    };

    return (
      <div>
        {loading || !materialId ? (
          <h5 className="text-center">
            <i className="fa fa-circle-o-notch fa-spin" /> {' '}
            {!materialId ? t('No material assigned to the bin') : t('Loading')}
          </h5>
        ) : (
          <div>
            <Row>
              <Col sm={12} className="margin-bottom-15">
                <ReactTable
                  className="-highlight"
                  data={jogArray}
                  columns={this.getColumns(material, t)}
                  sorted={this.state.sorted}
                  onSortedChange={sorted => this.setState({ sorted })}
                  showPaginationTop={false}
                  showPaginationBottom={false}
                  showPageSizeOptions={false}
                  resizable={false}
                  minRows={1}
                  defaultPageSize={50}
                />
              </Col>
            </Row>
            {!device.autoTuning && (
              <>
                <Row>
                  <Col sm={8}/>
                  <Col sm={4}>
                    <ControlLabel>{t('Jog Interval')}</ControlLabel>
                    <FormGroup>
                      <InputGroup>
                        <FormControl
                          name="jogInterval"
                          type="number"
                          min={0.1}
                          max={5}
                          step={0.05}
                          value={jogInterval}
                          onChange={handleJogIntervalChange}
                          bsSize="sm"
                        />
                        <InputGroup.Addon>
                          {t('sec')}
                        </InputGroup.Addon>
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} className="text-right">
                    {!batchStore.jogTestRunning ? (
                      <p>
                        <Button onClick={onClose}>{t('Close')}</Button>
                        {' '}
                        <Button onClick={clear}>
                          {t('Clear')}
                        </Button>
                        {' '}
                        <Button onClick={interpolate}>
                          {t('Interpolate')}
                        </Button>
                        {' '}
                        <Button bsStyle="info" onClick={(e) => {
                          e.preventDefault();
                          batchStore.runJogTest(material, jogArray, device);
                        }}>
                          {t('Auto Test')}
                        </Button>
                        {' '}
                        <LoadingButton
                          bsStyle="primary"
                          onClick={() => {
                            saveJog(device, jogTable, () => {
                              onClose();
                            });
                          }}
                          label={t('Save')}
                          loadingLabel={t('Saving')}
                          isLoading={saving}
                        />
                      </p>
                    )
                      : (
                        <Button bsStyle="info" onClick={() => batchStore.stopJogTest()}>
                          {t('Stop Test')}
                        </Button>
                      )
                    }
                  </Col>
                </Row>
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(inject('jogStore', 'batchStore')(observer(JogTable)));
